import {FC} from 'react'
import {DateRow} from 'components/SearchForm/DateRow'

export const Birthday: FC = () => {
  return <DateRow header="生年月日" startName="birthdayStart" endName="birthdayEnd" />
}
